import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getCurrencySign, toggleModal } from "../store/common";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { productImagePath } from "../utils/product.util";
import { getTranslate, getActiveLanguage } from "react-localize-redux";
import html from "react-inner-html";
import ProductDetailContainer from "../routes/ProductDetail/containers/ProductDetailContainer";

const ProductModalContainer = ({
  toggleModal,
  getLobingModalStatus,
  product,
  currencySign,
  translate,
  manufacturer,
  compatibility,
  currentLanguage
}) => (
  <Modal
    size="lg"
    className="product_modal"
    isOpen={getLobingModalStatus}
    toggle={() => toggleModal("product_modal", false)}
    centered={true}
  >
    <ModalHeader>
      {" "}
      <h1>
        {product && product.texts && (product.texts[currentLanguage].name || product.texts[currentLanguage].flex_name)}
      </h1>
    </ModalHeader>
    <ModalBody>
      {product && <ProductDetailContainer product={product} />}
    </ModalBody>
    <ModalFooter>
      <Button
        color="btn btn-secondary btn-danger"
        onClick={() => toggleModal("product_modal", false)}
      >
        {translate("containers.productModalContainer.close")}
      </Button>
    </ModalFooter>
  </Modal>
);

const mapStateToProps = state => ({
  translate: getTranslate(state.locale),
  currentLanguage: getActiveLanguage(state.locale).id || 1,
  getLobingModalStatus: state.common.modals
    ? state.common.modals.product_modal
    : null,
  product: state.product.detail,
  currencySign: getCurrencySign(state.common.user.currency.sign),
  manufacturer: state.common.manufacturer,
  compatibility: state.common.compatibility
});

const mapDispatchToProps = dispatch => ({
  toggleModal: (modalName, action) => dispatch(toggleModal(modalName, action))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductModalContainer);



// WEBPACK FOOTER //
// ./src/containers/ProductModal.js